export default "__VITE_ASSET__dffe47c1__"